export class Progress {
  constructor(
    public progressId?: string,
    public buName?: string,
    public region?: string,
    public country?: string,
    public providerName?: string,
    public providerId?: string,
    public campaignName?: string,
    public campaignId?: string,
    public date?: string,
    public total?: number,
    public success?: number,
    public fail?: number,
    public status?: string,
    public files?: any,
    public errorSummary?: any,
    public redshiftTotal?: any,
    public redshiftDistinctIDoTotal?: any,
    public redshiftDistinctIAmTotal?: any
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/modules/progress/progress.model.ts